import { ChangeDetectorRef, Component, signal } from '@angular/core';
import { CardComponent, CardModule, ColComponent, ColDirective, ContainerComponent, IColumn, ProgressComponent, RowComponent, SmartTableComponent, SmartTableModule, TemplateIdDirective, ToastBodyComponent, ToastComponent, ToastHeaderComponent, ToasterComponent } from '@coreui/angular-pro';
import { RangeFilterComponent } from '../../../components/range-filter/range-filter.component';
import { event } from 'jquery';
import { IQueryFilterRange } from '../../../models/vehicle-status.model';
import { ActivatedRoute, Params, Router, RouterLink } from '@angular/router';
import { ChartjsModule } from '@coreui/angular-chartjs';
import { ChartData, ChartOptions } from 'chart.js';
import { VehicleUtilizationStatistics, DepotUtilizationStatistics, LeagueRegionData, LeagueDepotData } from '../../../models/depot-insight.model';
import { GlobalDataService } from '../../../services/global-data.service';
import { NetworkSummaryService } from '../../../services/network-summary.service';
import { VehicleStatusService } from '../../../services/vehicle-status.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NavItemsService } from '../../services/nav-service';

@Component({
  selector: 'app-region-summary',
  standalone: true,
  imports: [
    CommonModule,
    ContainerComponent,
    RowComponent,
    ColComponent,
    RangeFilterComponent,
    CardModule,
    ChartjsModule,
    SmartTableModule,
    SmartTableComponent,
    TemplateIdDirective,
    ColDirective,
    RouterLink,
    ProgressComponent,
    ToasterComponent,
    ToastComponent,
    ToastHeaderComponent,
    ToastBodyComponent
  ],
  templateUrl: './region-summary.component.html',
  styleUrl: './region-summary.component.scss'
})
export class RegionSummaryComponent {
  departmentId! : string;
  routeSubscription: Subscription;
  rangeSelector: IQueryFilterRange = IQueryFilterRange.ThisYear

  screenTitle = '';

  mostFrequentlyUsedVehicles: VehicleUtilizationStatistics[] = [];
  unutilisedVehiclesData: DepotUtilizationStatistics[] = [];

  leagueRegionData: LeagueRegionData[] = [];
  leagueDepotData: LeagueDepotData[] = [];

  paramsId: number = -1;
  regionName: string|undefined = '';

  networkUtilizationChartOptions: ChartOptions = {
    scales: {
      y: {
        suggestedMin: 0,
        suggestedMax: 100,
      },
    },
    parsing: {
      xAxisKey: 'label',
      yAxisKey: 'averagePercentageOfUtilization',
    },
    // TODO: Need to figure out how to get newlines in this [02282025]
    plugins: {
      tooltip: {

        callbacks: {
          title: function(tooltipItems) {
            return [
              `${tooltipItems[0].label} (%)`
            ];
          }
        //   label: function(tooltipItem) {
        //     const dataPoint: any = tooltipItem.raw;
        //     return [
        //       `Month: ${dataPoint.monthName}`,
        //       `Average Utilization: ${dataPoint.averagePercentageOfUtilization}`,
        //       `Utilized: ${dataPoint.utilized}`,
        //       `Total: ${dataPoint.total}`,
        //       `Available: ${dataPoint.available}`,
        //       `Not Available: ${dataPoint.notAvailable}`,
        //       `Unutilized: ${dataPoint.unutilized}`,
        //     ];
        //   },
        },
      }
    },
  };
  networkUtilisationData: ChartData = {
    labels: [],
    datasets: [],
  };

  vehicleUtilizationData: ChartData = {
    labels: [],
    datasets: [
      {
        data: [], // Example distribution
        backgroundColor: [], // Adjust colors to match the chart
      },
    ],
  };

  vehicleStatusData = {
    labels: [] as any,
    datasets: [] as any,
  };
    // Table coloumn configs
    leagueDepotColumns: (IColumn | string)[] = [
      {
        label: 'Depot',
        key: 'depot_name',
        filter: true,
        sorter: true,
        _labelTemplateId: 'all',
        _style: { width: '20%' },
        _props: { class: 'fw-bold' }
      },
      { label: 'Today\'s Utilisation (%)', key: 'total_today_snapshot_count', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
      { label: 'Average Utilisation (%)', key: 'total_snapshot_count_in_range', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
      { label: 'Total Unused Count', key: 'total_utilized_count_in_range', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
      // { label: 'VOR Count Today', key: 'today_vor_count', _labelTemplateId: 'all', filter: false, sorter: true, _style: { width: '15%' }, _classes: 'text-muted small' },
    ];
    leagueRegionColumns: (IColumn | string)[] = [
      {
        label: 'Region',
        key: 'region',
        filter: true,
        _labelTemplateId: 'all',
        _style: { width: '20%' },
        _props: { class: 'fw-bold' }
      },
      { label: 'Today\'s Utilisation(%)', key: 'total_today_snapshot_count', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
      { label: 'Average Utilisation (%)', key: 'total_snapshot_count_in_range', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
      { label: 'Total Unused Count', key: 'total_utilized_count_in_range', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
      // { label: 'Today\'s VOR Count', key: 'today_vor_count', _labelTemplateId: 'all', filter: false, sorter: true, _style: { width: '15%' }, _classes: 'text-muted small' },
    ];
    unutilisedByDayColumns: (IColumn | string)[] = [
      {
        label: 'Depot',
        key: 'depot_name',
        filter: true,
        _labelTemplateId: 'all',
        _style: { width: '20%' },
        _props: { class: 'fw-bold' }
      },
      { label: 'Unused Count', key: 'unutilized_count', _labelTemplateId: 'all', filter: false, sorter: true, _style: { width: '15%' }, _classes: 'text-muted small' },
      { label: 'Date', key: 'snapshot_date', _labelTemplateId: 'all', filter: false, sorter: true, _style: { width: '15%' }, _classes: 'text-muted small' },
    ];
    frequentUnutilisedColumns: (IColumn | string)[] = [
      {
        label: 'Vehicle',
        key: 'vehicle_registration',
        filter: true,
        _labelTemplateId: 'all',
        _style: { width: '40%' },
        _props: { class: 'fw-bold' }
      },
      { label: 'Depot', key: 'vehicle_depot', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '40%' }, _classes: 'text-muted small' },
      { label: 'Unused Count', key: 'unutilized_count', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '20%' }, _classes: 'text-muted small' },
    ];


    // Toaster 
    visible = signal(false);
    percentage = signal(0);

    toggleToast() {
      this.visible.update((value) => !value);
    }

    onToasterVisibleChange($event: boolean) {
      this.visible.set($event);
      this.percentage.set(this.visible() ? this.percentage() : 0);
    }

    onToasterTimerChange($event: number) {
      this.percentage.set($event * 25);
    }


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private globalData: GlobalDataService,
    private networkSummaryService: NetworkSummaryService,
    private cdr: ChangeDetectorRef,
    private vehicleStatusService: VehicleStatusService,
    private navDataService : NavItemsService
  ) {
    this.routeSubscription = this.route.params.subscribe(res => this.onRouteChange(res));
  }

  ngOnInit() {
    this.rangeSelector = this.route.snapshot.queryParams["range"] || "1"
  }

  handleRouteFilterChange($event: any) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        range: $event.currentTarget?.value
      },
      queryParamsHandling: "merge"
    }).then(res => {
      this.onRouteChange(this.route.snapshot.params)
    })
  }

  async onRouteChange(params: Params): Promise<void> {
    const { regionId, departmentId } = params
    this.departmentId = departmentId

    this.paramsId = regionId;

    this.navDataService.navDataReceivedObservable.subscribe(() => {
      this.regionName = this.navDataService.findRegionName(
        parseInt(departmentId as string),
        parseInt(regionId as string)
      );
      this.screenTitle = `${this.regionName} Utilisation `;
    });

    // const range = this.route.snapshot.queryParamMap?.get("range")
    const range = this.route.snapshot.queryParamMap?.get("range") as IQueryFilterRange

    if (!departmentId || departmentId?.length <= 0) {
      this.router.navigate(["/"])
    }

    let _params = this.globalData.generateApiQueryParams({
      range: range as IQueryFilterRange
    });
    _params['region_id'] = this.paramsId.toString();

    this.networkSummaryService.getVehicleStatusData(_params)
      .then(res => {
        this.vehicleStatusData = this.networkSummaryService.refactorVehicleStatusData(res);
        this.cdr.detectChanges();
      })

    this.networkSummaryService.getVehicleUtilization(_params)
      .then(res => {
        this.mostFrequentlyUsedVehicles = this.networkSummaryService.refactoryVehicleUtilizationData(res)
        this.cdr.detectChanges();
      })

    this.networkSummaryService.getDepotUtilizationStatistics(_params)
      .then(res => {
        this.unutilisedVehiclesData =res; // this.networkSummaryService.refactorUntilizedData(res);
        this.cdr.detectChanges();
      })

    this.networkSummaryService.getRegionLeagueTableStatsDepots(regionId, _params)
      .then(res => {
        // ? this is a bit of duplication, but for simplicity its easier to edit if we want to use this service on a different page, with the original data.
        // ? We can refactor this later? maybe a reusable method that omits an array of object keys?
        // TODO: look into this.
        this.leagueDepotData = res.map((item) => {
          // const { depot_id, ...rest } = item;
          item = {...item, region_id: regionId }
          

          return item as LeagueDepotData
        })
        this.cdr.detectChanges()
      })

    this.networkSummaryService.getDepartmentLeagueTableStatsRegions(departmentId, _params)
      .then(res => {
        this.leagueRegionData = res.map((item: any) => {
           item = {...item, region: {region_id: item.region_id, region_name: item.region_name }, }
          // console.log(item)
          return item
        })
        this.cdr.detectChanges()
      })

    // Setup first graph
    this.networkSummaryService.getUtilizationStatistics(_params)
    .then(res => {
      this.networkUtilisationData = {
        labels: [],
        datasets: [],
      };
      this.cdr.detectChanges()

      this.networkUtilisationData = this.networkSummaryService.refactorUtilizationDataForLineGraph(res, range)
      console.log("change")
      this.cdr.detectChanges()
    })
    // Donut chart
    this.vehicleStatusService.getVehicleUtilizationStatistics(_params).subscribe((data) => {
      const { vehicleUtilizationData } = this.vehicleStatusService.refactorVehicleStatsDataForGraphs(data)
      this.vehicleUtilizationData = vehicleUtilizationData;
      this.cdr.detectChanges()
    })
  }


  gotoDepot(item: LeagueDepotData) {
    const region = this.navDataService.findRegionByDepotId(parseInt(this.departmentId), item.depot_id);
    debugger
    if (region) {
      const route = `/department/${this.departmentId}/region/${region.id}/depot/${item.depot_id}/`;
      this.router.navigate([route]);
    } else {
      this.toggleToast();
    }
   
  }

}
